module.exports = __webpack_public_path__ + "static/media/b4-black-spanish.c035cf36.png";